import * as React from "react"

export function RequiredField({ label, hideLabel = false, hint, error, attempt, children }: { label: string; hideLabel?: boolean; hint?: string; error?: string; attempt: number; children: React.ReactElement<React.InputHTMLAttributes<HTMLInputElement>> }) {
    const fieldId = React.useId()
    const hintId = hint ? `${fieldId}-hint` : undefined
    const errorId = error ? `${fieldId}-error` : undefined
    const describedBy = [hintId, errorId].filter(Boolean).join(" ") || undefined
    return <label className={`ah-field ah-detail-field ${error ? "is-invalid" : ""}`} data-shake={attempt % 2}>
        <span className={hideLabel ? "ah-visually-hidden" : undefined}>{label}</span>
        {React.cloneElement(children, { "aria-invalid": Boolean(error), "aria-describedby": describedBy })}
        {hint && <small id={hintId}>{hint}</small>}
        {error && <small id={errorId} className="ah-field-error" aria-live="polite">{error}</small>}
    </label>
}

export function Field({ label, hideLabel = false, hint, children }: { label: string; hideLabel?: boolean; hint?: string; children: React.ReactNode }) {
    return <label className="ah-field"><span className={hideLabel ? "ah-visually-hidden" : undefined}>{label}</span>{children}{hint && <small>{hint}</small>}</label>
}
